import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { vPermission } from './directives/permission'
import './style.css'

// Intercepteur global fetch : redirige vers login sur 401
const originalFetch = window.fetch
window.fetch = async (...args) => {
  const response = await originalFetch(...args)
  const url = typeof args[0] === 'string' ? args[0] : (args[0] as Request).url
  const isAuthRoute = url.includes('/api/auth/')
  const isAlreadyOnLogin = router.currentRoute.value.name === 'login'
  if (response.status === 401 && !isAuthRoute && !isAlreadyOnLogin) {
    const { useAuthStore } = await import('./stores/auth')
    const authStore = useAuthStore()
    authStore.user = null
    authStore.isAuthenticated = false
    router.push({ name: 'login' })
  }
  return response
}

const app = createApp(App)

app.use(createPinia())
app.use(router)

// Directives globales
app.directive('permission', vPermission)

app.mount('#app')
